import { types } from 'mobx-state-tree';

export const ConfirmModal = types
  .model('ConfirmModal', {
    isOpen: false,
    title: '',
    content: '',
    withConfirm: true,
    cancelDisabled: false,
  })
  .actions((self) => {
    let scopeResolve: (value: boolean) => void;

    return {
      show(title: string, content: string, withConfirm: boolean = true) {
        self.title = title;
        self.content = content;
        self.isOpen = true;
        self.withConfirm = withConfirm;
        return new Promise<boolean>((resolve) => {
          scopeResolve = resolve;
        });
      },

      confirm() {
        self.isOpen = false;
        self.cancelDisabled = false;
        scopeResolve(true);
      },

      cancel() {
        self.isOpen = false;
        self.cancelDisabled = false;
        scopeResolve(false);
      },

      disableCancel(flag: boolean) {
        self.cancelDisabled = flag;
      },
    };
  });
